module.exports = __webpack_public_path__ + "img/lead-service1.289d4954.jpg";